import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="subscription-setup"
export default class extends Controller {
  static targets = ["frequencySection", "countrySection"];

  connect() {
    // setTimeout(() => {
      this.updateSections();
    // }, 1000);
  }

  planChanged() {
    this.updateSections();
    const planSelected = this.element.querySelector(
      'input[name="plan"]:checked',
    );
    if (planSelected && this.hasFrequencySectionTarget) {
      this.frequencySectionTarget.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  frequencyChanged() {
    this.updateSections();
    const frequencySelected = this.element.querySelector(
      'input[name="frequency"]:checked',
    );
    if (frequencySelected && this.hasCountrySectionTarget) {
      this.countrySectionTarget.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  updateSections() {
    const planSelected = this.element.querySelector(
      'input[name="plan"]:checked',
    );
    if (planSelected) {
      this.frequencySectionTarget.style.display = "";
    } else {
      this.frequencySectionTarget.style.display = "none";
      this.countrySectionTarget.style.display = "none";
      this.updateFrequencyPrices(null);
      return;
    }

    const frequencySelected = this.element.querySelector(
      'input[name="frequency"]:checked',
    );
    if (frequencySelected) {
      this.countrySectionTarget.style.display = "";
    } else {
      this.countrySectionTarget.style.display = "none";
    }

    this.updateFrequencyPrices(planSelected.value);
  }

  updateFrequencyPrices(selectedPlan) {
    const monthlyLabel = this.element.querySelector(
      'label[for="frequency_monthly"]',
    );
    if (monthlyLabel) {
      const priceSpans = monthlyLabel.querySelectorAll("span.bg-black");
      if (priceSpans.length >= 2) {
        if (selectedPlan === "two") {
          priceSpans[0].style.display = "none";
          priceSpans[1].style.display = "";
        } else {
          priceSpans[0].style.display = "";
          priceSpans[1].style.display = "none";
        }
      }
    }
    const yearlyLabel = this.element.querySelector(
      'label[for="frequency_yearly"]',
    );
    if (yearlyLabel) {
      const priceSpans = yearlyLabel.querySelectorAll("span.bg-black");
      if (priceSpans.length >= 2) {
        if (selectedPlan === "two") {
          priceSpans[0].style.display = "none";
          priceSpans[1].style.display = "";
        } else {
          priceSpans[0].style.display = "";
          priceSpans[1].style.display = "none";
        }
      }
    }

    const annualLines = this.element.querySelectorAll("[data-plan-annual]");
    annualLines.forEach((line) => {
      if (selectedPlan && line.dataset.planAnnual === selectedPlan) {
        line.style.display = "";
      } else {
        line.style.display = "none";
      }
    });
  }
}
